import { Link } from "react-router-dom";
import paths from "routes/paths";

export default function OcareAppPage() {
  return <section className="card p-4">
    <h2>OCare App</h2>
    <p className="text-muted">Manage prescription conflicts on the Oliveeb side before orders reach Ocare.</p>
    <div className="alert alert-light border" role="note">The OCare section is visible to admin portal users. Prescription data and review actions still require the dedicated prescription-reviewer permission.</div>
    <h3 className="fs-8 mt-3">Conflict Management</h3>
    <p>Review source documents, correct extracted medication details, and record how patient and medication differences were resolved.</p>
    <ol>
      <li>Upload external prescriptions for a resident and AFH, or open a prescription from the review queue.</li>
      <li>Resolve each flagged difference, or hold the draft for clarification.</li>
      <li>Forward the verified order to Ocare for final approval.</li>
    </ol>
    <p className="text-muted">Unresolved drafts remain in this admin portal. Forwarding does not activate a medication.</p>
    <div><Link className="btn btn-primary" to={paths.prescriptionReviews}>Open Conflict Management</Link></div>
  </section>;
}
